import { render, staticRenderFns } from "./study-build-progress.vue?vue&type=template&id=65fefb92&scoped=true&"
import script from "./study-build-progress.vue?vue&type=script&lang=js&"
export * from "./study-build-progress.vue?vue&type=script&lang=js&"
import style0 from "./study-build-progress.vue?vue&type=style&index=0&id=65fefb92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fefb92",
  null
  
)

component.options.__file = "study-build-progress.vue"
export default component.exports